<script setup>
import Button from 'primevue/button';
import Message from 'primevue/message';

defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['refresh']);
</script>

<template>
  <Transition name="update-banner">
    <div v-if="visible" class="update-available-banner" role="alert">
      <Message severity="info" :closable="false" class="update-available-banner-message">
        <div class="update-available-banner-content">
          <span class="update-available-banner-text">
            🔄 A new version of BayHive is available.
          </span>
          <Button
            label="Refresh page"
            icon="pi pi-refresh"
            size="small"
            @click="emit('refresh')"
          />
        </div>
      </Message>
    </div>
  </Transition>
</template>

<style scoped>
.update-available-banner {
  position: sticky;
  z-index: var(--p-bayhive-layout-topbar-z-index);
  top: 0;
  flex: 0 0 auto;
  padding: var(--p-bayhive-spacing-sm) var(--p-bayhive-spacing-md);
}

.update-available-banner-message {
  margin: 0;
}

.update-available-banner-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--p-bayhive-spacing-md);
  width: 100%;
}

.update-available-banner-text {
  font-weight: 600;
}

.update-banner-enter-active,
.update-banner-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.update-banner-enter-from,
.update-banner-leave-to {
  opacity: 0;
  transform: translateY(-0.5rem);
}
</style>
